module.exports = __webpack_public_path__ + "static/media/icon-instructions.fc38193b.svg";